import React, { useState, useEffect } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Menu,
  MenuItem,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  FormControl,
  InputLabel,
  Box,
  Modal,
  IconButton,
  Typography,
  TablePagination,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Close } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch, useUpdate, useDelete } from "../../hooks";

const AddBanner = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [errors, setErrors] = useState({});
  const [bannerForm, setBannerForm] = useState({ name: "", logo: "" });
  const [isEditMode, setEditMode] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedBannerId, setSelectedBannerId] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [data, setData] = useState("");
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    message: "",
    status: "",
  });

  // Pagination states
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const loginToken = useSelector((state) => state.user.logintoken);
  const [errorTimestamp, setErrorTimestamp] = useState(null);

  const initializeBanners = () => {
    setBannerForm({
      name: "",
      logo: "",
    });
  };

  //get All Banners data
  useEffect(() => {
    fetchData();
  }, []);

  //get All Banners data
  const {
    data: bannersData,
    isLoading: isBannersLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllBanners"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  const {
    data: createBannersData,
    isLoading: createBannersLoading,
    error: createBannersError,
    fetchData: fetchCreateData,
  } = useFetch(BASE_URL_TEST + urls("createBanner"), {
    method: "POST",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: updateBannersData,
    isLoading: updateBannersLoading,
    error: updateBannersError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  const {
    data: deleteBannersData,
    isLoading: deleteBannersLoading,
    error: deleteBannersError,
    deleteData: fetchDeleteData,
  } = useDelete(BASE_URL_TEST, {
    method: "DELETE",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  useEffect(() => {
    if (error) {
    } else if (bannersData && bannersData["status"] === true) {
      setData(bannersData["data"]);
    }
  }, [bannersData, error]);

  //Create Banners
  useEffect(() => {
    if (createBannersError) {
    } else if (createBannersData && createBannersData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: createBannersData["message"],
        status: createBannersData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (createBannersData && createBannersData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: createBannersData["message"],
        status: createBannersData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [createBannersData, createBannersError]);

  //Update Banners
  useEffect(() => {
    if (updateBannersError) {
    } else if (updateBannersData && updateBannersData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: updateBannersData["message"],
        status: updateBannersData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (updateBannersData && updateBannersData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: updateBannersData["message"],
        status: updateBannersData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [updateBannersData, updateBannersError]);

  //Delete Banners
  useEffect(() => {
    if (deleteBannersError) {
    } else if (deleteBannersData && deleteBannersData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: deleteBannersData["message"],
        status: deleteBannersData["status"],
      });
      setDeleteModalOpen(true);
      fetchData();
    } else if (deleteBannersData && deleteBannersData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: deleteBannersData["message"],
        status: deleteBannersData["status"],
      });
      setDeleteModalOpen(true);
      fetchData();
    }
  }, [deleteBannersData, deleteBannersError]);
  // Filter data based on search
  const handleSearch = (event) => setSearch(event.target.value);

  const filteredData =
    data && data.length > 0
      ? data
          .sort((a, b) => b.banner_id - a.banner_id) // Sort by ID in descending order
          .filter(
            (item) =>
              item.type === "banner" && // "Banner" type data
              ((item.banner_id &&
                item.banner_id
                  .toString()
                  .toLowerCase()
                  .includes(search.toLowerCase())) ||
                (item.name &&
                  item.name.toLowerCase().includes(search.toLowerCase())))
          )
      : data;

  const handleMenuOpen = (event, bannerId) => {
    setAnchorEl(event.currentTarget);
    setSelectedBannerId(bannerId);
  };

  const handleMenuClose = () => setAnchorEl(null);

  const handleAdd = () => {
    setEditMode(false);
    initializeBanners();
    setErrors({});
    setOpen(true);
  };

  const handleSubmit = () => {
    let validationErrors = {};
    if (!bannerForm.logo) {
      validationErrors.logoError = "please upload Image";
      setErrors(validationErrors);
      return;
    }
    console.log("formdata");
    setErrors({});

    const formdata = new FormData();
    formdata.append("type", "banner");
    formdata.append("name", bannerForm["name"]);
    formdata.append("description", "");
    formdata.append(
      "imageurl",
      selectedFile ? selectedFile : bannerForm["image_url"]
    );
    if (isEditMode) {
      formdata.append(
        "status",
        bannerForm["status"] === "Active"
          ? 1
          : bannerForm["status"] === "Inactive"
          ? 0
          : ""
      );
      for (let [key, value] of formdata.entries()) {
        console.log("Form Data Contentsupdate:", `${key}: ${value}`);
      }
      const updateUrl = urls("updateBanner", bannerForm["id"]);
      fetchUpdateData(updateUrl, formdata);
    } else if (!isEditMode) {
      for (let [key, value] of formdata.entries()) {
        console.log("Form Data Contents:", `${key}: ${value}`);
      }
      fetchCreateData(formdata);
    }
  };

  const handleEdit = (bannerData) => {
    setEditMode(true);
    setOpen(true);
    setBannerForm({
      ...bannerForm,
      name: bannerData["name"],
      logo: bannerData["image_url"],
      status:
        bannerData["status"] === 1
          ? "Active"
          : bannerData["status"] === 0
          ? "Inactive"
          : "",
      id: bannerData["banner_id"],
    });
    setAnchorEl(null);
  };

  // Handle delete
  const handleDelete = (bannerId) => {
    const deleteUrl = urls("deleteBanner", bannerId);
    fetchDeleteData(deleteUrl);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setBannerForm({ name: "", logo: "" });
    setEditMode(false);
    setErrors({});
    setSnackbarState({
      message: "",
      status: "",
    });
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBannerForm({
        ...bannerForm,
        logo: URL.createObjectURL(e.target.files[0]),
      });
      setSelectedFile(file);
    }
  };

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClose = () => {
    setOpen(false);
    setModalOpen(false);
    setDeleteModalOpen(false);
    setErrors({});
    if (!createBannersError) {
      setErrors({});
    }
    if (isEditMode) {
      if (!updateBannersError) {
        setErrors({});
      }
    }

    setSnackbarState({
      message: "",
      status: "",
    });
  };

  return (
    <Box sx={{ padding: 2, backgroundColor: "#F9FAFC" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <TextField
          variant="outlined"
          placeholder="Search"
          size="small"
          value={search}
          onChange={handleSearch}
          sx={{ width: "30%", backgroundColor: "#FFF", borderRadius: 1 }}
        />
        <Button
          variant="contained"
          color="success"
          startIcon={<AddIcon />}
          onClick={handleAdd}
        >
          Add
        </Button>
      </Box>
      <TableContainer component={Paper} sx={{ borderRadius: "20px" }}>
        <Table>
          <TableHead sx={{ backgroundColor: "#F5F5F5" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>ID</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Image</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>STATUS</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>ACTION</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={2} align="center">
                  <Typography>No records found</Typography>
                </TableCell>
              </TableRow>
            ) : (
              filteredData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((banner) => {
                  return (
                    <TableRow key={banner.banner_id}>
                      <TableCell>{banner.banner_id}</TableCell>
                      <TableCell>{banner.name}</TableCell>
                      <TableCell>
                        {banner.image_url ? (
                          <img
                            src={banner.image_url}
                            alt="logo"
                            width={40}
                            height={40}
                          />
                        ) : (
                          "No Image"
                        )}
                      </TableCell>
                      <TableCell>
                        <Typography
                          color={
                            banner.status === "Active"
                              ? "green"
                              : banner.status === "Inactive"
                              ? "red"
                              : "orange"
                          }
                        >
                          {banner.status == 1
                            ? "Active"
                            : banner.status == 0
                            ? "Inactive"
                            : ""}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <MoreVertIcon
                          onClick={(e) => handleMenuOpen(e, banner.banner_id)}
                        />
                        <Menu
                          anchorEl={anchorEl}
                          open={
                            Boolean(anchorEl) &&
                            selectedBannerId === banner.banner_id
                          }
                          onClose={handleMenuClose}
                        >
                          <MenuItem onClick={() => handleEdit(banner)}>
                            Edit
                          </MenuItem>
                          <MenuItem
                            onClick={() => handleDelete(banner.banner_id)}
                          >
                            Delete
                          </MenuItem>
                        </Menu>
                      </TableCell>
                    </TableRow>
                  );
                })
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
      <Dialog
        open={isDeleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      >
        <DialogTitle>
          {snackbarState.status === true ? "Success" : "Error"}
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: snackbarState.status === true ? "green" : "red",
            }}
          >
            {snackbarState.message}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              alignSelf: "center",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "calc(100vw - 24px)", sm: 400 },
            maxWidth: "100%",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            position: "relative",
          }}
        >
          <IconButton
            sx={{ position: "absolute", top: 8, right: 8 }}
            onClick={() => setOpen(false)}
          >
            <Close />
          </IconButton>
          <Typography variant="h6" mb={2}>
            {isEditMode ? "Edit Banner" : "Add Banner"}
          </Typography>
          <TextField
            name="name"
            label="Name"
            fullWidth
            margin="dense"
            value={bannerForm.name}
            onChange={(e) =>
              setBannerForm({
                ...bannerForm,
                name: e.target.value,
              })
            }
            sx={{ mb: 2 }}
          />
          <input type="file" accept="image/*" onChange={handleImageUpload} />
          {errors.logoError && (
            <Typography color="error" sx={{ mt: 1 }}>
              {errors.logoError}
            </Typography>
          )}
          {bannerForm.logo && (
            <img src={bannerForm.logo} alt="Preview" width={50} height={50} />
          )}
          {isEditMode && (
            <FormControl fullWidth sx={{ mt: 3 }}>
              <InputLabel id="status-label">Status</InputLabel>
              <Select
                labelId="status-label"
                id="status-select"
                value={bannerForm?.status || ""}
                onChange={(e) =>
                  setBannerForm({
                    ...bannerForm,
                    status: e.target.value,
                  })
                }
                label="Status"
              >
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
              </Select>
            </FormControl>
          )}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button onClick={handleModalClose}>Cancel</Button>
            <Button variant="contained" color="success" onClick={handleSubmit}>
              {isEditMode ? "Update" : "Add"}
            </Button>
          </Box>
        </Box>
      </Modal>
      <Dialog open={isModalOpen} onClose={() => setModalOpen(false)}>
        <DialogTitle>
          {snackbarState.status === true ? "Success" : "Error"}
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: snackbarState.status === true ? "green" : "red",
            }}
          >
            {snackbarState.message}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              alignSelf: "center",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AddBanner;
